import { useEffect, useState } from "react";

/** Breakpoints passend zu den Media Queries in app-shell.scss. */
export const MOBILE_QUERY = "(max-width: 768px)";
export const NARROW_QUERY = "(max-width: 992px)";

export const useMediaQuery = (query: string): boolean => {
  const [matches, setMatches] = useState<boolean>(() => window.matchMedia(query).matches);

  useEffect(() => {
    const mediaQuery = window.matchMedia(query);
    const update = (): void => setMatches(mediaQuery.matches);
    update();
    mediaQuery.addEventListener("change", update);
    return () => mediaQuery.removeEventListener("change", update);
  }, [query]);

  return matches;
};
